module.exports = __webpack_public_path__ + "static/Storer_top_Eis_Charlie-f4435efba29157a75d04c8bc92e709f2-f4435efba29157a75d04c8bc92e709f2.svg";